import { useState, useContext, useRef } from "react"
import "./sendNotificationPanel.css"
import { sendNotification } from "../../services/notificationService.js";
import AsyncSelect from "react-select/async"

import { SearchContext } from "../../context/searchNameContext.js"


export default function SendNotificationPanelAdmin({ clousePanel }) {

    const [title, setTitle] = useState("")
    const [body, setBody] = useState("")
    const [value, setValue] = useState([])
    const [target, setTarget] = useState(0)

    const { loadOptionsNameTeam, loadOptionsName } = useContext(SearchContext)

    const handleSend = async () => {
        if (target === 0) {
            await Promise.all(value.map(user =>
                sendNotification(user.value, title, body, "", null)
            ))
        } else {
            await Promise.all(value.map(team =>
                sendNotification(null, title, body, "", team.value)
            ))
        }
        clousePanel()
    }

    const handleChangeTarget = () => {
        if (target === 0) setTarget(1)
        else setTarget(0)
        setValue([])
    }

    return (
        <div className="chat-panel">
            <div className="panel-header">
                <p className="ns-form-title">Enviar notificación</p>
                <button className="btn-close" onClick={() => clousePanel()}>✕</button>
            </div>

            <div className="ns-field">
                <label className="ns-label">Enviar a</label>
                <div style={{ backgroundColor: "#f1f3f4", padding: "4px", width: "180px", borderRadius: "10px" }}>
                    <button
                        className={`tab-btn ${target === 0 ? "tab-btn--active" : ""}`}
                        onClick={handleChangeTarget} disabled={target === 0}
                    >
                        Usuarios
                    </button>
                    <button
                        className={`tab-btn ${target === 1 ? "tab-btn--active" : ""}`}
                        onClick={handleChangeTarget} disabled={target === 1}
                    >
                        Grupos
                    </button>
                </div>
            </div>

            <div className="ns-field">
                {target === 0 ? (
                    <>
                        <label className="ns-label">Usuario</label>
                        <AsyncSelect
                            isMulti
                            defaultOptions
                            loadOptions={loadOptionsName}
                            value={value}
                            onChange={setValue}
                            placeholder="Buscar a usuarios..."
                        />
                    </>
                ) : (
                    <>
                        <label className="ns-label">Grupos</label>
                        <AsyncSelect
                            isMulti
                            defaultOptions
                            loadOptions={loadOptionsNameTeam}
                            value={value}
                            onChange={setValue}
                            placeholder="Buscar a grupos..."
                        />
                    </>
                )}
            </div>

            <div className="ns-field">
                <label className="ns-label">Título</label>
                <input
                    className="ns-input"
                    name="titulo"
                    placeholder="Título"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                />
            </div>

            <div className="ns-field">
                <label className="ns-label">Mensaje</label>
                <textarea
                    className="ns-input ns-textarea"
                    name="cuerpo"
                    placeholder="Escribe un mensaje..."
                    value={body}
                    onChange={(e) => setBody(e.target.value)}
                />
            </div>
            <div className="panel-footer">
                <button
                    onClick={handleSend}
                    className="ns-submit"
                    disabled={value.length === 0 || !title || !body}
                >
                        Enviar   
                </button>
            </div>
        </div>
    )
}